<div class="indicator-container" [class.disabled]="!enabled" #indicator>
    <div class="color-picker-wrapper">
        <input
            disabled
            class="color-input"
            [cpToggle]=""
            [(colorPicker)]="color"
            [style.background]="enabled ? color : ''" />
    </div>

    <div class="color-text-container">
        <h6 class="color-name">
            {{ title | translate: { status } }}
        </h6>
        <span class="color-text">
            {{ enabled ? (showAlpha ? this.rgb + ', ' + this.alpha + '%' : this.rgb) : ' ' }}
        </span>
    </div>
</div>
